import { RNG } from "rot-js";
import { LevelMap, WorldTile } from "../../engine/map/LevelMap";
import { RNGGenerator } from "../../lib/rng";
import { drawTile, FloorTypes } from "./Map";

export type BasicTile = WorldTile<FloorTypes>;

export class BasicMap extends LevelMap<FloorTypes> {
  hasGenerated = false;
  constructor(
    width: number,
    height: number,
    public rng: RNGGenerator,
    public depth = 1
  ) {
    super(drawTile, width, height);
  }

  generate(rng: typeof RNG) {
    this.hasGenerated = true;
    this.fillAll(() => new WorldTile(FloorTypes.OOB));
  }
}
